// extracted by mini-css-extract-plugin
export var baseButton = "styles-module__base-button___UfdcI";
export var destructivePrimary = "styles-module__destructive-primary___A3be7";
export var tertiary = "styles-module__tertiary___OSreE";
export var secondaryGray = "styles-module__secondaryGray___POeOj";
export var secondary = "styles-module__secondary___H4ckU";
export var primary = "styles-module__primary___QGD4z";
export var small = "styles-module__small___tDdbT";
export var flat = "styles-module__flat___JvBF6";
export var buttonGroup = "styles-module__buttonGroup___mQjsE";